function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2h50v50H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.45 2.615)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M12.296 11.095L22.47.894l10.173 10.2"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.983 21.311)",
  fill: "#E57373"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.565,
  cy: 2.834,
  rx: 2.872,
  ry: 2.834
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.876,
  cy: 4.306,
  rx: 2.872,
  ry: 2.834
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.402,
  cy: 7.777,
  rx: 1.914,
  ry: 1.889
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.896 10.304h.241c1.6 0 2.896 1.297 2.896 2.896v4.01H0V13.2c0-1.6 1.296-2.896 2.896-2.896zm20.864.859h.242c1.6 0 2.896 1.297 2.896 2.896v3.057h-6.033V14.06c0-1.6 1.296-2.896 2.895-2.896z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.81 6.624h.484a3.86 3.86 0 013.86 3.861v6.855H5.95v-6.855a3.86 3.86 0 013.86-3.86z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.122 8.096h.483a3.86 3.86 0 013.861 3.861v5.426h-8.205v-5.426a3.86 3.86 0 013.86-3.86z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 23.648,
  cy: 8.759,
  rx: 1.914,
  ry: 1.889
})), /*#__PURE__*/React.createElement("path", {
  d: "M.527 11.292v30.595h43.432V11.292H.527zm3.534 3.546h36.818v23.73H4.06v-23.73z",
  stroke: "#371447",
  fill: "#E57373"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#371447",
  cx: 22.41,
  cy: 1.247,
  rx: 1.225,
  ry: 1.23
})));

function SvgFamilyMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFamilyMd;